import { cookieService } from "@/lib/cookie/cookieService";
import { create } from "zustand";

interface AuthState {
  token: string | null;
  refreshToken: string | null;
  expired: number | null;
  setToken: (state: { token: string; expired: number }) => void;
  setRefreshToken: (state: { refreshToken: string; expired: number }) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()((set) => ({
  token: null,
  refreshToken: null,
  expired: null,
  user: null,
  setToken: (state) => {
    set({ token: state.token, expired: state.expired });
    cookieService.set("token", state.token, {
      encrypt: true,
      expires: state.expired,
    });
  },
  setRefreshToken: (state) => {
    set({ refreshToken: state.refreshToken });
    cookieService.set("refreshToken", state.refreshToken, {
      encrypt: true,
      expires: state.expired,
    });
  },
  logout: () => {
    set({ token: null, refreshToken: null, expired: null });
    cookieService.remove("token");
    cookieService.remove("refreshToken");
    cookieService.remove("expired");
  },
}));
